import { DevSettings, Platform } from 'react-native';

const RELOAD_GUARD_KEY = 'tabbio-rtl-reload-guard';
const RELOAD_GUARD_TTL_MS = 30_000;

async function readSecureStore(key: string): Promise<string | null> {
  try {
    const SecureStore =
      require('expo-secure-store') as typeof import('expo-secure-store');
    return SecureStore.getItemAsync(key);
  } catch {
    return null;
  }
}

async function writeSecureStore(key: string, value: string) {
  try {
    const SecureStore =
      require('expo-secure-store') as typeof import('expo-secure-store');
    await SecureStore.setItemAsync(key, value);
  } catch {
    // ignore
  }
}

// Returns true if a reload is allowed right now (i.e. we have not already
// reloaded for RTL within the last RELOAD_GUARD_TTL_MS milliseconds). Stamps
// the guard before returning so concurrent callers cannot double-reload.
export async function claimNativeRtlReloadSlot(): Promise<boolean> {
  const now = Date.now();
  const stamp = await readSecureStore(RELOAD_GUARD_KEY);
  if (stamp) {
    const previous = Number.parseInt(stamp, 10);
    if (Number.isFinite(previous) && now - previous < RELOAD_GUARD_TTL_MS) {
      return false;
    }
  }
  await writeSecureStore(RELOAD_GUARD_KEY, String(now));
  return true;
}

export async function reloadNativeApp() {
  if (Platform.OS === 'web') return;
  // Both Android and iOS keep already-mounted views in their old layout
  // direction after I18nManager.forceRTL until the JS bundle reloads, so we
  // trigger one. Try expo-updates first (production / EAS builds), fall back
  // to DevSettings.reload (dev client / Expo Go).
  try {
    const Updates = require('expo-updates') as {
      reloadAsync: () => Promise<void>;
    };
    await Updates.reloadAsync();
    return;
  } catch {
    // expo-updates unavailable: fall through.
  }
  try {
    DevSettings.reload();
  } catch {
    // No reload mechanism available; user will need to relaunch manually.
  }
}
